import { useEffect, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import Lightbox from "@/components/Lightbox";
import Seo from "@/components/Seo";

export default function Portfolio() {
  const [photos, setPhotos] = useState([]);
  const [lb, setLb] = useState(null);

  useEffect(() => {
    api.get("/portfolio").then((r) => setPhotos(r.data)).catch(() => {});
  }, []);

  return (
    <main data-testid="portfolio-page" className="pt-32 pb-28">
      <Seo title="Portfolio — Bahare | Photography Portfolio, Los Angeles"
        description="Selected photography by Bahare — maternity, newborn, family, couples, portraits and branding in Los Angeles." />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <h1 className="font-serif text-5xl md:text-7xl font-light tracking-tight mb-16">Port<span className="italic">folio.</span></h1>
        </Reveal>
        <div className="masonry columns-1 sm:columns-2 lg:columns-3" data-testid="portfolio-page-grid">
          {photos.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.05} y={20}>
              <button onClick={() => setLb(i)} data-testid={`portfolio-page-photo-${p.id}`} className="block w-full cursor-zoom-in text-left">
                <img src={imgUrl(p.url)} alt={p.caption || "Photography by Bahare"} loading="lazy"
                  className="w-full h-auto hover:scale-[1.015] transition-transform duration-[1200ms] ease-out" />
              </button>
            </Reveal>
          ))}
          {photos.length === 0 && <p className="text-sm text-[#7A7A7A]">Photographs are being curated.</p>}
        </div>
        <Lightbox photos={photos} index={lb} onClose={() => setLb(null)} onNavigate={setLb} />
      </div>
    </main>
  );
}
